import {AbsctractValidator} from "./AbstractValidator";
import {RegexValidator} from "./RegexValidators";

export class CreditCardNumberValidator extends AbsctractValidator {
    _regex = {
      AMEX: {
        id: 3,
        name: "American Express",
        slug: "amex",
        pattern: /^3[47]\d{13}$/
      },
      DINERS: {
        id: 4,
        name: "Diners Club",
        slug: "diners",
        pattern: /^3(?:0[0-5]|[68]\d)\d{11}$/
      },
      ELO: {
        id: 6,
        name: "Elo",
        slug: "elo",
        pattern: /(4011|431274|438935|451416|457393|4576|457631|457632|504175|627780|636297|636368|636369|(6503[1-3])|(6500(3[5-9]|4[0-9]|5[0-1]))|(6504(0[5-9]|1[0-9]|2[0-9]|3[0-9]))|(650(48[5-9]|49[0-9]|50[0-9]|51[1-9]|52[0-9]|53[0-7]))|(6505(4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-8]))|(6507(0[0-9]|1[0-8]))|(6507(2[0-7]))|(650(90[1-9]|91[0-9]|920))|(6516(5[2-9]|6[0-9]|7[0-9]))|(6550(0[0-9]|1[1-9]))|(6550(2[1-9]|3[0-9]|4[0-9]|5[0-8]))|(506(699|77[0-8]|7[1-6][0-9]))|(509([0-9][0-9][0-9])))/
      },
      AURA: {
        id: 8,
        name: "Aura",
        slug: "aura",
        pattern: /^50\d{14}/
      },
      HIPERCARD: {
        id: 5,
        name: "Hipercard",
        slug: "hipercard",
        pattern: /^(606282\d{10}(\d{3})?)|(3841\d{15})$/
      },
      MASTERCARD: {
        id: 2,
        name: "Mastercard",
        slug: "master",
        pattern: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/
      },
      VISA: {
        id: 1,
        name: "Visa",
        slug: "visa",
        pattern: /^4\d{12}(?:\d{3})?$/
      },
      DISCOVER: {
        id: 7,
        name: "Discover",
        slug: "discover",
        pattern: /^(6011\d{12,15}|622\d{13,16}|64\d{14,17}|65\d{14,17})/
      },
      JCB: {
        id: 9,
        name: "JCB",
        slug: "jcb",
        pattern: /^35\d{14,17}/
      }
    };

    clean (value) {
      if (typeof value === "number") value = value.toString();
      if (value && value.length > 0) value = value.replace(/\D/g, "");
      return value;
    }

    isValidWithLuhn () {
      let value = this.clean(this.input);
      value = value.split("");

      let _value = value.slice(0, -1).reverse(),
          _sum = 0,
          _dg;

      // Calcula a soma com módulo
      for (let n = 0; n < _value.length; n++) {
        let _val = parseInt(_value[n]);
        if (n % 2 === 0) {
          let _n = _val * 2;
          if (_n > 9) _n -= 9;
          _sum += _n;
        } else {
          _sum += _val;
        }
      }
      
      // Calcula dígito, retorna
      _dg = 10 - (_sum % 10);
      
      return (parseInt(value.pop()) === _dg);
    }

    getFlag () {
      this.input = this.input.replace(/[^\d]/g, "");

      const _keys = Object.keys(this._regex);

      for (let k in _keys) {
        let _key = _keys[k],
            _item = this._regex[_key];

        if (_item.pattern.test(this.input)) return _item.slug;
      }
      return "none";
    }

    isValidNew () {

      this.input = this.input.replace(/[^\d]/g, "");

      const _keys = Object.keys(this._regex);

      for (let k in _keys) {
        let _key = _keys[k],
            _item = this._regex[_key];

        if (_item.pattern.test(this.input)) {
          return true;
        }
      }

      return false;
    }

    isValid() {
      console.log(this.getFlag());
      console.log("FLAG: " + this.isValidNew());
      console.log("LUHN: " + this.isValidWithLuhn());
      return this.isValidNew();/// && this.isValidWithLuhn();
      /*
        const regexs = {
            card1: new RegExp(/^5[1-5][0-9]{14}/),
            card2: new RegExp(/^4[0-9]{12}(?:[0-9]{3})/),
            card3: new RegExp(/^3[47][0-9]{13}$/),
            card4: new RegExp(/^3(?:0[0-5]|[68][0-9])[0-9]{11}/),
            card5: new RegExp(/^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|(((5067)|(4576)|(4011))\d{0,12})|(650)\d{0,13})$/)
        };
        this.input = this.input.replace(/-|_/g, '');
        for(let i in regexs) {
            if(this.input && !this.input.match("_") && this.input.length > 0 && regexs[i].test(this.input)) {
                return true;
            }
        }
        return false;
      */
    }
    message() {
        return !this.isValid() ? "Número de cartão inválido" : "OK";
    }
}

export class CreditCardExpirationValidator extends RegexValidator {
    constructor(input) {
        const regex = new RegExp("00/00");
        super(input, regex)
    }
    isValid() {
        let input = this.input.replace(/[^0-9]/g, "");
        const month = parseInt(input.slice(0,2), 10);
        const year = parseInt("20" + input.slice(2), 10);
        let date = new Date();
        if(year.toString().length === 4 && year > date.getFullYear() && month >= 1 && month <= 12 || (date.getFullYear() === year && month >= date.getMonth()+1)) {
            return true;
        }
        return false;
    }
    message() {
        return !this.isValid() ? "Data inválida" : "OK";
    }
}



// WEBPACK FOOTER //
// ./src/validator/CreditCardValidators.js